import { useContext, useEffect } from "react";
import useFirestore from "../basic/useFirestore";
import { collection, getDocs, query, where } from "firebase/firestore";
import { FirebaseContext } from "../../providers/FirebaseProvider/FirebaseProvider";

// Hide soft-deleted groups from the manager's list. A missing/undefined/null
// `deletedAt` means the group is active; any value means it was archived.
// Filtered client-side (not with a `where`) so groups created before the field
// existed — which have no `deletedAt` at all — are still shown.
export const excludeDeletedGroups = (groups = []) =>
  groups.filter((group) => !group.deletedAt);

function useUserGroups(managerId) {
  const { firestoreDb } = useContext(FirebaseContext);

  const firestoreQuery = async () =>
    getDocs(
      query(
        collection(firestoreDb, "groups"),
        where("managerId", "==", managerId),
      ),
    );

  const parsingFuntion = (data) =>
    excludeDeletedGroups(
      data.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      })),
    );

  const { data, error, isLoading, refreshData } = useFirestore(
    firestoreQuery,
    parsingFuntion,
  );

  useEffect(() => {
    refreshData();
  }, [managerId]);

  return {
    data,
    error,
    isLoading,
    refreshData,
  };
}

export default useUserGroups;
